<template>
  <div class="py-[160px]">
    <div class="text-[48px] text-center leading-[67px]">
      {{ $t('tong-lei-chang-jing-tui-jian') }}
    </div>
    <div class="relative py-[80px]">
      <swiper :slides-per-view="4" :space-between="24" @init="initSwiper">
        <swiper-slide v-for="(item, index) in data.recommended_data" :key="index">
          <SceneCard :data="item" :refresh="refresh" @create="onCreate(item)"></SceneCard>
          <!-- 场景卡片 -->
        </swiper-slide>
      </swiper>
      <Arrow direction="left" :disabled="isFirstPage" @click="slidePrev" />
      <Arrow direction="right" :disabled="isLastPage" @click="slideNext" />
    </div>
    <scene-button class="block mx-auto w-[218px] h-[48px] text-[20px]" @click="moreScene">
      <div class="flex items-center gap-x-[12px]">
        {{ $t('cha-kan-geng-duo-chang-jing') }}
        <icon-arrow-right class="text-[22px]" />
      </div>
    </scene-button>
  </div>
</template>

<script setup lang="ts">
import type { Swiper as SwiperType } from 'swiper/types';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { MockSceneDetails } from '~/api/interface/scene';
import IconArrowRight from '~/assets/svg/icon-arrow-right.svg?component';
// import { getEnv } from '~/utils/env'
import { useSceneOps } from '@/features/createWork';
import Arrow from '../components/arrow.vue';
import SceneButton from '../components/button.vue';
import SceneCard from '../components/scene-card.vue';

const props = defineProps<{
  data: typeof MockSceneDetails;
  refresh: () => void;
}>();

const { createOps } = useSceneOps();

const swiperInstance = ref<SwiperType | null>(null);

const initSwiper = (swiper: SwiperType) => {
  swiperInstance.value = swiper;
};

const isFirstPage = computed(() => swiperInstance.value?.realIndex === 0);
const isLastPage = computed(
  () => swiperInstance.value?.realIndex === props.data.recommended_data.length - 1,
);

const slidePrev = () => {
  swiperInstance.value?.slidePrev();
};

const slideNext = () => {
  swiperInstance.value?.slideNext();
};

const moreScene = () => {
  const userInfo = useUserInfo();
  if (userInfo.value) {
    navigateTo(`${location.origin}/workspace/scene`, { external: true });
  } else {
    navigateTo(
      `/login?redirect=${encodeURIComponent(encodeURIComponent(`${location.origin}/workspace/scene`))}`,
      {
        external: true,
      },
    );
  }
};

const onCreate = (item: (typeof MockSceneDetails.recommended_data)[0]) => {
  createOps('create', {
    id: item.id,
    is_custom_config: false,
  });
};
</script>
